import { render } from "./UserRolesCard.vue?vue&type=template&id=1c9d2c85&scoped=true"
import script from "./UserRolesCard.vue?vue&type=script&lang=js"
export * from "./UserRolesCard.vue?vue&type=script&lang=js"

import "./UserRolesCard.vue?vue&type=style&index=0&id=1c9d2c85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9d2c85"]])

export default __exports__